import { ToastMessage } from '@aurrica-web/core-data';

export type ToastType = NonNullable<ToastMessage['type']>;

export interface ToastTheme {
  bg: string;
  accent: string;
}

export const TOAST_THEMES: Record<ToastType, ToastTheme> = {
  error: { bg: '#F64B3C', accent: '#C81912' },
  warning: { bg: '#EF8D32', accent: '#CC561E' },
  success: { bg: '#2D6A4F', accent: '#004440' },
  info: { bg: '#3282B8', accent: '#05478A' },
};

/**
 * WhatsApp-style speech bubble: round body + tail at bottom-right.
 * viewBox 0 0 70 80 — circle center ~(35, 30), tail tip ~(44, 68).
 */
export const TOAST_SPEECH_BUBBLE =
  'M43.805 67.68c.3-.2.7-.4 1-.5 14.1-4.2 24.5-17.4 24.5-33.4C69.3 15.4 54 0 35 0S.7 15.4.7 34.3c0 13.5 7.8 25.2 19.1 30.8l3.1 10c.8 2.5 3.7 3.6 5.9 2.2L43.8 67.68Z';

/** Icons centered in the round part of the bubble (viewBox 0 0 70 80). Error uses stroked lines in the template. */
export const TOAST_ICON_PATHS: Record<Exclude<ToastType, 'error'>, string> = {
  warning:
    'M32 25v11c0 1.7 1.3 3 3 3s3-1.3 3-3V25c0-1.7-1.3-3-3-3s-3 1.3-3 3Zm3 14c1.7 0 3-1.4 3-3.1s-1.3-3.1-3-3.1-3 1.4-3 3.1 1.3 3.1 3 3.1Z',
  success:
    'M41.3 22.35c1 .8 1.2 2.3.3 3.3L29.7 41.5c-.4.5-1 .8-1.6.8-.6 0-1.2-.3-1.6-.8l-6.4-8.3c-.9-1-.7-2.5.3-3.3 1-.8 2.5-.6 3.3.4l5.2 6.7 9.4-12.2c.8-1 2.4-1.2 3.3-.4Z',
  info:
    'M35.63 18.43c-1.8-.9-3.8-.6-5.4.5-1.6 1.1-2.5 2.9-2.5 4.9 0 1 .3 1.9.9 2.6l.7.8c1.1 1.1 2.2.5 2.9-.4.2-.2.5-.5.8-.7.8-.7 1.7-1.1 2.7-1.2 1-.1 2 .1 2.9.6.9.5 1.7 1.2 2.1 2.1.5.9.7 1.9.7 2.9-.1 1-.4 1.9-1 2.7-.6.8-1.5 1.4-2.5 1.7-.8.3-1 .3-1.8.3h-.7c-1.2 0-2.1 1-2.1 2.1v3.5c0 1.2 1 2.1 2.1 2.1h.7c1.2 0 2.1-1 2.1-2.1 0-.5.4-1 .9-1.1.2 0 .3-.1.4-.1 1.9-.6 3.6-1.8 4.8-3.4 1.2-1.6 1.9-3.5 2-5.5.1-2-.4-4-1.4-5.7-1-1.7-2.5-3.1-4.3-3.9Z',
};

export const TOAST_DECOR_CIRCLE_LG = { cx: 58, cy: 48, r: 9 } as const;
export const TOAST_DECOR_CIRCLE_MD = { cx: 26, cy: 54, r: 5 } as const;
export const TOAST_DECOR_CIRCLE_SM = { cx: 18, cy: 30, r: 2.5 } as const;

export const TOAST_DECOR_BLOB =
  'M11.6 70.4C11.5 69.8 11 69.2 10.3 69 9.6 68.8 8.8 69 8.3 69.6L5.6 73C3.8 75.3.8 76.4-2.2 76.1C-9.4 75.5-16.9 76.1-24.4 78.1C-58.9 87.2-79.5 122.6-70.4 157.1C-61.3 191.7-25.9 212.3 8.6 203.2C43.1 194.1 63.7 158.7 54.6 124.2C49.4 104.4 35.5 89.1 18.1 81.5C15.2 80.2 13 77.7 12.4 74.6L11.6 70.4Z';

/** Bubble SVG height in px; used for half-above positioning. */
export const TOAST_BUBBLE_HEIGHT_PX = 56;

export function resolveToastType(
  type: ToastMessage['type'] | undefined,
): ToastType {
  return type ?? 'info';
}

export function toastIconPath(
  type: Exclude<ToastType, 'error'>,
): string {
  return TOAST_ICON_PATHS[type];
}
